<template>
  <div class="home_box">
    <div class="swiper-container maxcontainer"
         style="width: 100vw;height: 100vh;overflow: hidden;">
      <div class="swiper-wrapper">
        <!-- 第一屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="width: 100vw;height: 100vh;">
          <Banner></Banner>
        </div>
        <!-- 第二屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="  width: 100vw;height: 100vh;">
          <div class="service"
               style="overflow: hidden;">
            <div class="service_title">
              <div class="title_box">服务类型</div>
              <div class="service_tab_box">
                <div @click="serviceSwiperWay(0)"
                     :class="serviceSwiperId == 0?'service_tab_li service_tab_liSelect':'service_tab_li'">APP定制开发</div>
                <div @click="serviceSwiperWay(1)"
                     :class="serviceSwiperId == 1?'service_tab_li service_tab_liSelect':'service_tab_li'">高端网站建设</div>
                <div @click="serviceSwiperWay(2)"
                     :class="serviceSwiperId == 2?'service_tab_li service_tab_liSelect':'service_tab_li'">小程序定制开发</div>
                <div @click="serviceSwiperWay(3)"
                     :class="serviceSwiperId == 3?'service_tab_li service_tab_liSelect':'service_tab_li'">微信公众号开发</div>
                <div @click="serviceSwiperWay(4)"
                     :class="serviceSwiperId == 4?'service_tab_li service_tab_liSelect':'service_tab_li'">H5开发</div>
              </div>
            </div>
            <div class="service_banner">
              <el-carousel indicator-position="none"
                           ref="service"
                           height="71vh"
                           arrow="never"
                           @change="serviceChenge">
                <el-carousel-item style="height:100%"
                                  v-for="(item,index) in serviceList"
                                  :key="index">
                  <div class="service_banner_item"
                       :style="'background-image: url('+item.beijing+');background-size:'+serviceSize+';'">
                    <div class="left_box"
                         @mouseover="serviceoverWay()"
                         @mouseout="serviceOutWay()">
                      <div class="text_box">
                        <div class="text1">{{item.yingiwen}}</div>
                        <div class="text2">{{item.leixing}}</div>
                        <div class="text3">
                          {{item.jianjie}}
                        </div>
                        <div class="text4"></div>
                        <div class="text5">
                          {{item.jieshao}}
                        </div>
                      </div>
                      <div class="more"
                           @click="serviceWay(item)">&gt;&gt;查看更多&lt;&lt;</div>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
        <!-- 第三屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="  width: 100vw;height: 100vh;">
          <div class="plan_box">
            <div class="title_box">开发服务流程</div>
            <div class="introduce_box">
              我们拥有专业的技术开发团队，基于平台化的开发模式，为用户提供快速和高性价比的定制开发服务
              标准化的交付流程和交付体系，确保服务质量的贴心、优质，让您放心、省心
            </div>
            <div class="plan_ul_box">
              <div class="plan_ul_li"
                   v-for="item,index in planList"
                   :key="index"
                   @mouseover="planoverWay(item,index)"
                   @mouseout="planOutWay(item,index)">
                <div class="number">{{index+1}}</div>
                <div class="plan_ul_li_bgc"></div>
                <div class="icon"
                     :style="'background-image: url('+ item.icon+')'"></div>
                <h5>{{item.title}}</h5>
                <div class="text">
                  <p>{{item.p1}}</p>
                  <p>{{item.p2}}</p>
                  <p>{{item.p3}}</p>
                  <p>{{item.p4}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 第二屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="  width: 100vw;height: 100vh;">
          <div class="guarantee">
            <div class="title_box">服务保障</div>
            <div class="title_info">
              完善的定制开发服务流程，在售前、售中、售后您的服务过程中，<br>
              为客户提供完善的系统服务，7*24小时服务待命，第一时间响应客户需求。
            </div>
            <div class="step">
              <div :class="stepData.title == '售前'?'ISli li':'li'"
                   @click="stepFun(1)">
                <div :class="stepData.title == '售前'?'img_boxIS1 img_box':'img_box'"></div>
                <h5>
                  售前
                </h5>
                <p>
                  高素质的售前手机应用软件开发服务团队，掌握专业的APP知识，及时解除你的疑惑
                </p>
              </div>
              <div :class="stepData.title == '售中'?'ISli li':'li'"
                   @click="stepFun(2)">
                <div :class="stepData.title == '售中'?'img_boxIS2 img_box':'img_box'"></div>
                <h5>
                  售中
                </h5>
                <p>
                  专业的项目策划、技术研发、UI设计 项目管控，保证产品如期交付。
                </p>
              </div>
              <div :class="stepData.title == '售后'?'ISli li':'li'"
                   @click="stepFun(3)">
                <div :class="stepData.title == '售后'?'img_boxIS3 img_box':'img_box'"></div>
                <h5>
                  售后
                </h5>
                <p>
                  高效的售后服务团队，搭配完善的售后服务流程，确保产品流畅运行。
                </p>
              </div>

            </div>
            <div class="titleH5"
                 :style="stepData.title == '售后'?'text-align: right;':stepData.title == '售中'?'text-align: center;':'text-align: left;'">{{stepData.title}}</div>
            <div class="titleH5_info">
              {{stepData.content}}
            </div>
          </div>
        </div>

        <!-- 第四屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="  width: 100vw;height: 100vh;">

          <div class="advantage_box">
            <div class="title_box"
                 style="margin-top:0.6388rem">我们的优势</div>
            <!-- <div class="seat_box"></div> -->
            <div class="numerical_box">
              <div class="numerical_conter_box">
                <div class="numerical_li">
                  <h5>{{ numerical.fuwu }}+</h5>
                  <p>服务客户</p>
                </div>
                <div class="numerical_li">
                  <h5>{{ numerical.huigou }}%</h5>
                  <p>客户回购率</p>
                </div>
                <div class="numerical_li">
                  <h5>{{ numerical.haoping }}%</h5>
                  <p>客户好评率</p>
                </div>
                <div class="numerical_li">
                  <h5>{{ numerical.hangye }}+</h5>
                  <p>行业服务</p>
                </div>
              </div>
            </div>

            <div class="advantage_ul">
              <div class="advantage_ul_li">
                <div class="advantage_ul_li_img">
                  <img src="../../static/images/icon/caozuo.png"
                       alt="" />
                </div>
                <div class="advantage_ul_li_text_box">
                  <div class="advantage_ul_li_text_title">使用操作便捷</div>
                  <div class="advantage_ul_li_text">
                    根据企业现有的工作流程进行定制，功能模块流程清晰，后台操作方便，易用性强。
                  </div>
                </div>
              </div>
              <div class="advantage_ul_li">
                <div class="advantage_ul_li_img">
                  <img src="../../static/images/icon/chengben.png"
                       alt="" />
                </div>
                <div class="advantage_ul_li_text_box">
                  <div class="advantage_ul_li_text_title">节省开发成本</div>
                  <div class="advantage_ul_li_text">
                    定制软件根据企业实际情况，仅开发企业所需的功能模块、删除没有实际使用价值的功能，缩短开发周期，从而节省开发费用。
                  </div>
                </div>
              </div>
              <div class="advantage_ul_li">
                <div class="advantage_ul_li_img">
                  <img src="../../static/images/icon/daima.png"
                       alt="" />
                </div>
                <div class="advantage_ul_li_text_box">
                  <div class="advantage_ul_li_text_title">源代码独立</div>
                  <div class="advantage_ul_li_text">
                    根据企业不同时期的发展需求，定制软件可以满足企业的升级迭代要
                    求，助力企业变革和发展
                  </div>
                </div>
              </div>
              <div class="advantage_ul_li">
                <div class="advantage_ul_li_img">
                  <img src="../../static/images/icon/anquan.png"
                       alt="" />
                </div>
                <div class="advantage_ul_li_text_box">
                  <div class="advantage_ul_li_text_title">安全性能保障</div>
                  <div class="advantage_ul_li_text">
                    独创的ServerKey，轻松防止恶意跨权操作；内置防火墙、短信、
                    人脸、指纹等多重安全功能，提供强有力的多维度安全保护。
                  </div>
                </div>
              </div>
              <div class="advantage_ul_li">
                <div class="advantage_ul_li_img">
                  <img src="../../static/images/icon/shiyong.png"
                       alt="" />
                </div>
                <div class="advantage_ul_li_text_box">
                  <div class="advantage_ul_li_text_title">落地实用性强</div>
                  <div class="advantage_ul_li_text">
                    根据企业现有的工作流程进行定制，功能模块流程清晰，后台操作方便，易用性强。
                  </div>
                </div>
              </div>
              <div class="advantage_ul_li">
                <div class="advantage_ul_li_img">
                  <img src="../../static/images/icon/zhuanye.png"
                       alt="" />
                </div>
                <div class="advantage_ul_li_text_box">
                  <div class="advantage_ul_li_text_title">专业服务团队</div>
                  <div class="advantage_ul_li_text">
                    定制软件开发是由专业的服务团队提供服务，任何时候系统出现故障，
                    由专人进行跟踪处理，解决您的后顾之忧。
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 第八屏 -->
        <div class="swiper-slide swiper-no-swiping"
             style="  width: 100vw;height: 100vh;">
          <div style="height: 100%"
               data-scroll="true">
            <div class="partner_box">
              <div class="title_box">联系我们</div>
              <!-- <div class="existing_box">已有<span>2648</span>企业选择我们</div> -->
              <div class="form_box">
                <div class="input_box">
                  <span>所在省份：</span>
                  <input id="leaveMessageProvince"
                         type="text">
                </div>
                <div class="input_box">
                  <span>所在城市：</span>
                  <input id="leaveMessageCity"
                         type="text">
                </div>
                <div class="input_box"
                     style="width:45%">
                  <span>您的姓名：</span>
                  <input id="leaveMessageName"
                         style="width: 79%;"
                         type="text">
                </div>
                <div class="input_box"
                     style="width:46.5%;margin-top:0.1042rem">
                  <span>定制开发类型：</span>
                  <input id="leaveMessageType"
                         style="width: 75%;"
                         type="text">
                </div>
                <div class="input_box"
                     style="width:45%;margin-top:0.1042rem">
                  <span>联系电话：</span>
                  <input id="leaveMessagePhone"
                         style="width: 79%;"
                         type="text">
                </div>
              </div>
              <div class="appointment"
                   @click="submitForm">
                立即预约
              </div>
            </div>
            <Footer></Footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/banner.vue";
import Footer from "@/components/footer.vue";
import { listProduct } from "@/api/product";
import { listExample } from "@/api/presentation";
import { listNews } from "@/api/news";
export default {
  components: {
    Footer,
    Banner
  },
  computed: {
    servicePage: {
      get () {
        return this.$store.state.servicePage
      },
      set (value) {
        this.$store.commit('putcurrentPage', value)
      }
    }
  },
  data () {
    return {
      // 第几屏
      HomeSwiperId: 0,
      swiper: '',
      // 第二屏参数
      numerical: {
        fuwu: 0,
        huigou: 0,
        haoping: 0,
        hangye: 0,
      },
      pages2: '',
      // 第三屏参数
      serviceSwiperId: 0,
      serviceSize: '100% 100%',
      serviceList: [
        {
          path: '/homePage/APPdevelopment',
          beijing: require('../../static/images/img/APPdingzhi.png'),
          yingiwen: 'App customization development',
          leixing: 'APP定制开发',
          jianjie: "APP手机软件，主要指安装在智能手机上的软件，完善原始系统的不足与个性化",
          jieshao: "智能手机，是指像个人电脑一样，具有独立的操作系统、独立的运行空间，可以由用户自行安装软件、游戏、导航等第三方服务商提供的程序，并可以通过移动通讯网络来实现无线网络接入手机类型的总称随着智能手机的普及，人们在沟通、社交、娱乐等活动中越来越依赖于手机app软件(app，英文application的简称，即应用软件，通常是指iPhone、安卓等手机应用软件)，手机软件是通过分析，设计，编码，生成软件，而手机软件是一种特殊的软件。"
        }, {
          path: '/homePage/Webconstruction',
          beijing: require('../../static/images/img/webkaifa.png'),
          yingiwen: 'High end website construction',
          leixing: '高端网站建设',
          jianjie: "网站(Website)是指在因特网上根据一定的规则，使用HTML(标准通用标记语言)等工具制作的用于展示特定内容相关网页的集合。",
          jieshao: "网站(Website)是指在因特网上根据一定的规则，使用HTML(标准通用标记语言)等工具制作的用于展示特定内容相关网页的集合，简单地说，网站是一种沟通工具，人们可以通过网站来发布自己想要公开的资讯，或者利用网站来提供相关的网络服务人们可以通过网页浏览器来访问网站，获取自己需要的资讯或者享受网络服务。"

        }, {
          path: '/homePage/Wechat',
          beijing: require('../../static/images/img/xiaochengxkaifa.png'),
          yingiwen: 'Applet customization development',
          leixing: '小程序定制开发',
          jianjie: "微信小程序，是一种不需要下载安装即可使用的应用。",
          jieshao: "微信小程序，英文名Wechat Mini Program，是一种不需要下载安装即可使用的应用，它实现了应用“触手可及”的梦想，用户扫一扫或搜一下即可打开应用。全面开放申请后，主体类型为企业、政府、媒体、其他组织或个人的开发者，均可申请注册小程序。微信小程序、微信订阅号微信服务号、微信企业号是并行的体系。微信小程序是一种不用下载就能使用的应用，也是一项创新，经过将近两年的发展，已经构造了新的微信小程序开发环境和开发者生态，微信小程序也是这么多年来中国IT行业里一个真正能够影响到普通程序员的创新成果。"
        }, {
          path: '/homePage/Wechat',
          beijing: require('../../static/images/img/gongzonghaokaifa.png'),
          yingiwen: 'WeChat official account development',
          leixing: '微信公众号开发',
          jianjie: "公众号在平台上实现文字、图片、语音、视频的全方位沟通、形成了一种主流的线上线下微信互动营销方式。",
          jieshao: "微信公众号是开发者或商家在微信公众平台上申请的应用账号，该帐号与QQ账号互通，平台上实现和特定群体的文字、图片、语音、视频的全方位沟通、互动，形成了一种主流的线上线下微信互动营销方式。"
        }, {
          path: '/homePage/H5',
          beijing: require('../../static/images/img/appkaifa.png'),
          yingiwen: 'H5 development',
          leixing: 'H5开发',
          jianjie: "H5是指第5代HTML，也指用H5语言制作的一切数字产品。所谓HTML是“超文本标记语言”的英文缩写。",
          jieshao: "H5的最显著的优势在于跨平台性：比如用互动大师搭建的站点与应用可以兼容PC端与移动端、Windows与Linux、安卓与IOS。它可以轻易地移植到各种不同的开放平台、应用平台上，打破各自为政的局面。这种强大的兼容性可以显著地降低开发与运营成本，可以让企业特别是创业者获得更多的发展机遇。"
        },
      ],
      // 第四屏参数
      stepData: {
        title: '售前',
        content: '一对一配备专属的项目经理，主导项目的需求分析、开发、测试、安装部署、培训、维护等服务过程，全程跟踪服务，再无后顾之忧。30分钟内的服务请求响应，确定问题的解决方案和解决时间。'
      },
      // 第五屏参数
      planList: [
        {
          icon: require('../../static/images/icon/qiatan.png'),
          isIcon: require('../../static/images/icon/isqiatan.png'),
          title: "商务洽谈分析",
          p1: "需求分析",
          p2: '优先级定义',
          p3: "信息架构设计",
          p4: "商业分析",
        },
        {
          icon: require('../../static/images/icon/cehua.png'),
          isIcon: require('../../static/images/icon/iscehua.png'),
          title: "产品策划",
          p1: "竞品分析",
          p2: '用户画像',
          p3: "技术可行性分析",
          p4: "产品评估",
        }, {
          icon: require('../../static/images/icon/yuanxing.png'),
          isIcon: require('../../static/images/icon/isyuanxing.png'),
          title: "UE原型设计",
          p1: "需求整理",
          p2: '功能板块设计',
          p3: "思维导图梳理",
          p4: "交互设计",
        }, {
          icon: require('../../static/images/icon/UI.png'),
          isIcon: require('../../static/images/icon/isUI.png'),
          title: "UI视觉设计",
          p1: "色彩分析",
          p2: '设计规范',
          p3: "界面设计",
          p4: "图标设计",
        }, {
          icon: require('../../static/images/icon/yanfa.png'),
          isIcon: require('../../static/images/icon/isyanfa.png'),
          title: "产品研发",
          p1: "架构搭建",
          p2: '数据结构设计',
          p3: "接口设计",
          p4: "技术选型",
        }, {
          icon: require('../../static/images/icon/code.png'),
          isIcon: require('../../static/images/icon/iscode.png'),
          title: "代码开发",
          p1: "定义代码规范",
          p2: '功能开发',
          p3: "代码优化",
          p4: "管理版本迭代",
        }, {
          icon: require('../../static/images/icon/ceshi.png'),
          isIcon: require('../../static/images/icon/isceshi.png'),
          title: "产品测试",
          p1: "不同机型测试",
          p2: '功能性测试',
          p3: "兼容性测试",
          p4: "多环境状态测试",
        }, {
          icon: require('../../static/images/icon/weihu.png'),
          isIcon: require('../../static/images/icon/isweihu.png'),
          title: "运营维护",
          p1: "运营指导",
          p2: '免费维护',
          p3: "数据流量分析",
          p4: "数据备份",
        },
      ],
      // 第六屏参数
      productId: 0,
      productList: [],
      queryParams: {
        productId: null,
        exampleTitle: null,
        createTime: null
      },
      exampleList: [],
      caseSwiper: '',
      // 第七屏参数
      informationId: 1,
      dataList: [],
      newsList: [],
      // 第八屏参数
      form: {},
    }
  },
  mounted () {
    this.getHomeSwiper()
    this.getData()
    this.categoryList()
    this.getCaseSwiper()
    this.getNewsList();
  },
  watch: {
    HomeSwiperId: {
      handler (e) {
        this.servicePage = e
        if (e == 4) {
          setTimeout(() => {
            this.page2Way();
          }, 100);
        }
        setTimeout(() => {
          this.numerical = {
            fuwu: 0,
            huigou: 0,
            haoping: 0,
            hangye: 0,
          };
        }, 100);
      }
    },
    servicePage: {
      handler (e) {
        if (e !== this.HomeSwiperId) {
          this.swiper.slideTo(e)
        }
      }
    }
  },
  methods: {
    // 获取初始数据
    getData () {
      listProduct({}).then(response => {
        this.productList = response.rows;
      });
    },
    // 首页整屏滚动初始化
    getHomeSwiper () {
      var _this = this
      this.swiper = new Swiper('.maxcontainer', {
        initialSlide: _this.servicePage,
        direction: 'vertical',
        loop: false, //不循环
        spaceBetween: 0, // swiper-slide 间的距离为0
        autoplay: false, // 不自动切换
        speed: 700, // 每次切换时长
        mousewheelControl: true, // 开启鼠标切换
        noSwiping: true,// 开启不允许切换
        onSlideChangeEnd: function (swiper) {
          _this.HomeSwiperId = swiper.activeIndex
        }
      });


    },
    // 第二屏数字加载
    page2Way () {
      var pages2 = setInterval(() => {
        if (this.numerical.fuwu < 200) {
          this.numerical.fuwu = this.numerical.fuwu + 2;
        }
        if (this.numerical.huigou < 100) {
          this.numerical.huigou = this.numerical.huigou + 1;
        }
        if (this.numerical.haoping < 100) {
          this.numerical.haoping = this.numerical.haoping + 1;
        }
        if (this.numerical.hangye < 20) {
          this.numerical.hangye = this.numerical.hangye + 1;
        }
        if (
          this.numerical.fuwu >= 200 &&
          this.numerical.huigou >= 100 &&
          this.numerical.haoping >= 100 &&
          this.numerical.hangye >= 20
        ) {
          clearInterval(pages2);
        }
      }, 20);
    },
    // 第三屏类型切换
    serviceSwiperWay (row) {
      this.$refs.service.setActiveItem(row)
      this.serviceSwiperId = row
    },
    // 第三屏轮播滚动后的索引
    serviceChenge (row) {
      this.serviceSwiperId = row
    },
    // 第三屏鼠标放上去背景发大
    serviceoverWay () {
      this.serviceSize = '110% 110%'
    },
    // 第三屏鼠标移开背景还原
    serviceOutWay () {
      this.serviceSize = '100% 100%'
    },
    // 第三屏查看更多
    serviceWay (row) {
      this.$router.push(row.path);
    },
    stepFun (row) {
      if (row == 1) {
        this.stepData = {
          title: '售前',
          content: '一对一配备专属的项目经理，主导项目的需求分析、开发、测试、安装部署、培训、维护等服务过程，全程跟踪服务，再无后顾之忧。30分钟内的服务请求响应，确定问题的解决方案和解决时间。'
        }
      } else if (row == 2) {
        this.stepData = {
          title: '售中',
          content: `拥有完整的服务体系，涵盖咨询、方案、实施、培训、技术支持、版本升级、二次开发与功能扩展等，使产品价值达到客户预期效果。7*24小时多种服务方式，包括QQ、微信、邮件、电话，现场服务与远程服务等。

过硬的产品和技术能力，丰富的服务经验和规范管理，10余年行业的实践经验与积累，是提供专业服务的基础。良好的技术规范和服务管理规范，是提供优质、高效服务的根本保障。

基于OA平台化的优势，系统运行稳定、错误率低，统一技术服务标准和规范，避免对技术人员的依赖程度。提升服务的效率和质量、降低服务的技术难度和服务成本，`
        }
      } else if (row == 3) {
        this.stepData = {
          title: '售后',
          content: `承诺在项目交付使用之后，保障系统安全可靠地运行，及时修复程序上出现的问题。从项目正式验收之日起，乙方为甲方提供为期一年，7*24小时的售后服务。终身免费提供终身项目建设规划咨询服务、书面规划修改方案、系统升级建议、咨询等等服务。

售后部将受理客户的不同需求并妥善做出处理，为该系统提供一年的免费技术支持和维护。

提供7*24小时服务，对于系统运行过程中出现的问题首先应通过热线电话解决；或通过公司 QQ进行沟通，如通过电话或互联网解决不了的，将派人员到现场指导。`
        }
      }
    },
    // 第四屏更多案例  移入
    whatbuttonoverWay () {
      var button = document.querySelector(".button")
      button.style.color = '#fff'
    },
    // 第五屏鼠标移入
    planoverWay (row, index) {
      var icon = document.querySelectorAll('.plan_ul_li')[index].querySelector('.icon')
      icon.style.backgroundImage = 'url(' + row.isIcon + ')'
    },
    // 第五屏鼠标移出
    planOutWay (row, index) {
      var icon = document.querySelectorAll('.plan_ul_li')[index].querySelector('.icon')
      icon.style.backgroundImage = 'url(' + row.icon + ')'
    },
    // 第六屏类型
    categoryWay (row) {
      this.productId = row
      if (row > 0) {
        this.queryParams.productId = row;
      } else {
        this.queryParams.productId = null;
      }
      this.categoryList();
    },
    // 第六屏案例获取
    categoryList () {
      listExample(this.queryParams).then(response => {
        this.exampleList = response.rows;
      });
    },
    // 第六屏轮播初始化
    getCaseSwiper () {
      this.caseSwiper = new Swiper('.qwer', {
        autoplay: false,
        initialSlide: 1,
        slidesPerView: 3,
        spaceBetween: 20,
        loop: false,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
      })
    },
    // 第六屏 轮播上一个
    caseSwiperPrev () {
      this.caseSwiper.slidePrev()
    },
    // 第六屏 轮播下一个
    caseSwiperNext () {
      this.caseSwiper.slideNext()
    },
    // 第七屏
    informationFun (row) {
      this.informationId = row
      this.getNewsList();
    },
    getNewsList () {
      listNews({ newsType: this.informationId }).then(response => {
        this.newsList = response.rows;
      });
    },
    details (row, index) {
      this.$router.push(
        {
          path: "/Journalism/details",
          query: {
            id: row,
            index: index,
            newsType: this.informationId
          }
        }
      )
    },
    // 第八屏
    submitForm () {
      this.form.leaveMessageProvince = document.getElementById("leaveMessageProvince").value;
      this.form.leaveMessageCity = document.getElementById("leaveMessageCity").value;
      this.form.leaveMessageType = document.getElementById("leaveMessageType").value;
      this.form.leaveMessageName = document.getElementById("leaveMessageName").value;
      this.form.leaveMessagePhone = document.getElementById("leaveMessagePhone").value;

      if (!this.form.leaveMessageProvince.trim() && !this.form.leaveMessageCity.trim() && !this.form.leaveMessageName.trim() && !this.form.leaveMessageType.trim() && !this.form.leaveMessagePhone.trim()) {
        this.$notify({
          title: '提示',
          message: '不能为空',
          type: 'info'
        });
        return
      }
      var appointment = document.querySelector('.appointment')
      appointment.innerHTML = '请稍后...'
      setTimeout(() => {
        addMessage(this.form).then(response => {
          this.$notify({
            title: '已发送',
            message: '请添加屏幕右侧微信或拨打电话联系',
            type: 'success'
          });
          this.reset();
          appointment.innerHTML = '立即预约'
        });
      }, 2000)
    },

    Jump (row) {
      this.$router.push(row);
    }
  }
}
</script>


<style lang="scss" scoped>
@keyframes moreframe {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.home_box {
  text-align: center;
  .banner_box {
    width: 100vw;
    height: 100vh;
  }
  .title_box {
    display: inline-block;
    position: relative;
    font-size: 0.153rem;
    font-family: MicrosoftYaHei;
    color: #ffffff;
    opacity: 1;
    margin: 0.225rem 0 0.1383rem;
  }
  .title_box::before {
    content: "";
    position: absolute;
    left: -0.4083rem;
    top: 58%;
    transform: translateY(-50%);
    width: 0.2083rem;
    height: 0.2188rem;
    background-image: url("../../static/images/icon/title_left.png");
    background-size: 100% 100%;
  }
  .title_box::after {
    content: "";
    position: absolute;
    right: -0.4083rem;
    top: 58%;
    transform: translateY(-50%);
    width: 0.2083rem;
    height: 0.2188rem;
    background-image: url("../../static/images/icon/title_right.png");
    background-size: 100% 100%;
  }
  .advantage_box {
    width: 100%;
    height: 100%;
    background-color: rgb(138, 134, 134);
    background-image: url("../../static/images/img/biejing.png");
    background-size: 100% 100%;
    .numerical_box {
      height: 0.6208rem;
      background: #ebebeb;
      opacity: 1;
      .numerical_conter_box {
        display: flex;
        justify-content: space-between;
        margin: 0 auto;
        padding: 0 1.875rem;
        .numerical_li {
          margin-top: 0.05rem;
          h5 {
            font-size: 0.25rem;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #e71623;
            letter-spacing: 0.0104rem;
            opacity: 1;
          }
          p {
            text-align: center;
            font-size: 0.1063rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #e71623;
            letter-spacing: 0.0104rem;
            opacity: 1;
          }
        }
      }
    }
    .advantage_ul {
      margin-top: 0.1504rem;
      padding: 0 1.875rem;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .advantage_ul_li {
        width: 3.0313rem;
        height: 0.849rem;
        background: #ffffff;
        opacity: 1;
        border-radius: 0px;
        margin-bottom: 0.125rem;
        display: flex;
        transition: 0.3s;
        .advantage_ul_li_img {
          width: 0.2708rem;
          height: 0.2708rem;
          margin: 0.2917rem 0.1563rem 0 0.2083rem;
        }
        .advantage_ul_li_text_box {
          flex: 1;
          .advantage_ul_li_text_title {
            text-align: left;
            font-size: 0.1042rem;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #2f2f2f;
            letter-spacing: 0.0104rem;
            opacity: 1;
            margin-top: 0.2083rem;
          }
          .advantage_ul_li_text {
            text-align: left;
            font-size: 0.0729rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 0.125rem;
            color: #999999;
            letter-spacing: 0.0052rem;
            opacity: 1;
            padding-right: 0.2083rem;
            margin-top: 0.0729rem;
          }
        }
      }
      .advantage_ul_li:hover {
        box-shadow: 0px 0px 0.1042rem #ff4d4d;
      }
    }
  }
  .seat_box {
    height: 0.5rem;
    width: 100%;
    background-color: #00000000;
  }
  .service {
    .service_title {
      height: 29vh;
      background-color: #000;
      .title_box {
        margin-top: 0.6208rem;
      }
      .service_tab_box {
        display: flex;
        justify-content: space-between;
        padding: 0 1.875rem;
        font-size: 0.0833rem;
        font-family: MicrosoftYaHei;
        color: #ffffff65;
        margin-top: 0.03rem;
        .service_tab_li {
          width: 0.896rem;
          height: 0.2469rem;
          border: 0.0052rem solid #313131;
          opacity: 1;
          border-radius: 0rem;
          text-align: center;
          line-height: 0.2469rem;
          cursor: pointer;
          transition: 0.3s;
        }
        .service_tab_li:hover {
          color: #fff;
          border-color: #fff;
        }
        .service_tab_liSelect {
          border-color: #fff;
          background-color: #fff;
          color: #000;
          font-weight: 700;
        }
        .service_tab_liSelect:hover {
          border-color: #fff;
          background-color: #fff;
          color: #000;
          font-weight: 700;
        }
      }
    }
    .service_banner {
      height: 71vh;
      overflow: hidden;
      .service_banner_item {
        position: relative;
        display: flex;
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
        background-position: center;
        transition: 0.3s;
        z-index: 1;
        >>> el-carousel__container {
          height: 100% !important;
        }
        .left_box {
          width: 50%;
          background-color: #00000080;
          transition: 1s;
          cursor: pointer;
          .text_box {
            position: absolute;
            top: 50%;
            left: 19%;
            color: #fff;
            width: 2.6rem;
            text-align: left;
            transition: 1s;
            transform: translateY(-50%);
            z-index: 1;
            .text1 {
              font-size: 0.1354rem;
              font-family: Cambria-Bold;
              color: #ffffff;
              letter-spacing: 0px;
              opacity: 1;
            }
            .text2 {
              font-size: 0.2396rem;
              font-family: MicrosoftYaHei-Bold;
              color: #ffffff;
              opacity: 1;
              margin: 0.1063rem 0;
            }
            .text3 {
              font-size: 0.0833rem;
              font-family: MicrosoftYaHei;
              line-height: 0.125rem;
              color: #ffffff;
              opacity: 1;
              text-align: justify;
              text-justify: inter-word;
            }
            .text4 {
              width: 0.2604rem;
              height: 0.0052rem;
              background: #ffffff;
              opacity: 0.6;
              border-radius: 0px;
              margin: 0.1063rem 0;
            }
            .text5 {
              font-size: 0.0833rem;
              font-family: MicrosoftYaHei;
              line-height: 0.1667rem;
              color: #ffffff;
              opacity: 1;
              text-align: justify;
              text-justify: inter-word;
            }
          }
          .more {
            position: absolute;
            right: 19%;
            top: 45%;
            font-size: 0.1563rem;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            letter-spacing: 0.0156rem;
            opacity: 0;
            z-index: -1;
          }
        }
        .left_box:hover {
          width: 100%;
          .more {
            z-index: 1;
            animation: moreframe 0.3s 0.8s forwards;
          }
        }
      }
    }
  }
  .Whatcan_box {
    height: 100vh;
    overflow: hidden;
    .title_box {
      margin-top: 0.6208rem;
      color: #000;
    }
    .Whatcan_content_box {
      position: relative;
      background-color: #f36979;
      height: 77vh;
      transition: 0.3s;
      .menu_box {
        position: absolute;
        top: 43%;
        left: 18%;
        width: 1.401rem;
        transform: translateY(-50%);
        .whatLogo {
          height: 0.2604rem;
          background-image: url("../../static/images/img/whatlogo.png");
          background-size: 100% 100%;
        }
        .what_more_box {
          width: 1.401rem;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          .what_more_li {
            width: 0.6979rem;
            height: 0.4375rem;
            background: #23222b;
            margin-bottom: 0.0052rem;
            cursor: pointer;
            transition: 0.3s;
            user-select: none;
            .what_more_icon {
              width: 0.0938rem;
              height: 0.0938rem;
              margin: 0.0938rem auto 0.0521rem;
            }
            .what_more_text {
              text-align: center;
              font-size: 0.0781rem;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #ffffff;
              letter-spacing: 0.0104rem;
              opacity: 1;
            }
          }
        }
      }
      .what_text_box {
        position: absolute;
        top: 50%;
        left: 36%;
        width: 1.5938rem;
        transform: translateY(-50%);
        text-align: left;
        .title {
          font-size: 0.1563rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          letter-spacing: 0.0052rem;
          opacity: 1;
          margin-bottom: 0.0625rem;
        }
        p {
          font-size: 0.0833rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          letter-spacing: 0.0052rem;
          opacity: 1;
          line-height: 0.152rem;
        }
        .button {
          position: relative;
          width: 1.4063rem;
          height: 0.3281rem;
          border: 0.0052rem solid #ffffff;
          opacity: 1;
          border-radius: 0px;
          line-height: 0.3281rem;
          text-align: center;
          font-size: 0.0833rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          letter-spacing: 0.0052rem;
          opacity: 1;
          transition: 0.3s;
          cursor: pointer;
          .dibu {
            position: absolute;
            top: 0rem;
            left: 0rem;
            width: 0%;
            height: 100%;
            background-color: #fff;
            transition: 0.3s;
            z-index: -1;
          }
        }
        .button:hover {
          color: #23222b;
          .dibu {
            width: 100%;
          }
        }
      }
      .what_img_box {
        position: absolute;
        top: 50%;
        right: 18%;
        transform: translateY(-50%);
        width: 2.1198rem;
        height: 2rem;
      }
    }
  }
  .plan_box {
    width: 100%;
    height: 100%;
    background-color: #2c294d;
    .title_box {
      margin-top: 0.6208rem;
      color: #fff;
    }
    .introduce_box {
      width: 5.0417rem;
      margin: 0 auto;
      text-align: center;
      font-size: 0.086rem;
      font-family: MicrosoftYaHei;
      line-height: 0.124rem;
      color: #ffffff;
      opacity: 1;
    }
    .plan_ul_box {
      margin: 0.144rem 1.875rem 0px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .plan_ul_li {
        position: relative;
        width: 1.25rem;
        height: 1.5rem;
        border: 0.0052rem dashed #fff;
        border-radius: 0.1042rem;
        margin: 0 0.0521rem;
        margin-bottom: 0.1504rem;
        cursor: pointer;
        background: #ffffff00;
        overflow: hidden;
        z-index: 0;
        .plan_ul_li_bgc {
          position: absolute;
          top: 0rem;
          left: 0rem;
          width: 100%;
          height: 100%;
          background: linear-gradient(180deg, #97abff 0%, #f072b6 100%);
          opacity: 0;
          transition: 0.3s;
          z-index: -1;
        }
        .number {
          position: absolute;
          right: 0.0417rem;
          top: 0.0417rem;
          font-size: 0.082rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          opacity: 1;
          transition: 0.3s;
        }
        .icon {
          width: 0.2083rem;
          height: 0.2083rem;
          background-image: url("../../static/images/icon/cehua.png");
          background-size: 100% 100%;
          margin: 0px auto;
          margin-top: 0.2083rem;
          transition: 0.3s;
        }
        h5 {
          text-align: center;
          font-size: 0.1042rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          opacity: 1;
          margin-top: 0.082rem;
          margin-bottom: 0.0629rem;
        }
        .text {
          line-height: 0.1363rem;
          font-size: 0.0781rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          opacity: 1;
          transition: 0.3s;
          text-align: center;
        }
        .text:hover {
          line-height: 0.1563rem;
        }
      }
      .plan_ul_li:hover {
        border: 0.0052rem dashed #ffffff00;
        .plan_ul_li_bgc {
          opacity: 1;
        }
        .number {
          color: #000;
        }
        .icon {
          width: 0.4167rem;
          height: 0.4167rem;
          background-image: url("../../static/images/icon/iscehua.png");
          margin-top: 0.1042rem;
        }
      }
    }
  }
  .guarantee {
    width: 100vw;
    height: 100vh;
    .title_box {
      margin-top: 0.6088rem;
      color: #000;
    }
    .title_info {
      font-size: 0.1146rem;
      font-family: MicrosoftYaHei;
      line-height: 0.1654rem;
      color: #999999;
      opacity: 1;
    }
    .step {
      padding: 0.2344rem 1.875rem 0.2604rem;
      display: flex;
      justify-content: space-between;
      .li {
        width: 1.7396rem;
        height: 1.4323rem;
        background: #e3e3e3;
        opacity: 1;
        border-radius: 0.1042rem;
        cursor: pointer;
        transition: 0.3s;
        color: #999999;
        .img_box {
          width: 0.3854rem;
          height: 0.3854rem;
          transition: 0.3s;
          background-image: url("../../static/images/icon/ISshouqian.png");
          background-size: 100% 100%;
          margin: 0.1563rem auto 0.1042rem;
        }
        .img_boxIS1 {
          background-image: url("../../static/images/icon/shouqian.png") !important;
        }
        .img_boxIS2 {
          background-image: url("../../static/images/icon/shouzhong.png") !important;
        }
        .img_boxIS3 {
          background-image: url("../../static/images/icon/shouhou.png") !important;
        }
        h5 {
          font-size: 0.1042rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 0.2083rem;
          letter-spacing: 0.0052rem;
          opacity: 1;
        }
        p {
          text-align: left;
          font-size: 0.0729rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 0.1458rem;
          letter-spacing: 0.0052rem;
          opacity: 1;
          margin: 0 0.2604rem;
        }
      }
      .li:hover {
        background-color: #e71623;
        color: #fff;
        .img_box {
          background-image: url("../../static/images/icon/shouqian.png") !important;
        }
      }
      .li:nth-child(2):hover {
        .img_box {
          background-image: url("../../static/images/icon/shouzhong.png") !important;
        }
      }
      .li:nth-child(3):hover {
        .img_box {
          background-image: url("../../static/images/icon/shouhou.png") !important;
        }
      }
      .li:nth-child(2) {
        .img_box {
          background-image: url("../../static/images/icon/ISshouzhong.png");
        }
      }
      .li:nth-child(3) {
        .img_box {
          background-image: url("../../static/images/icon/ISshouhou.png");
        }
      }
      .ISli {
        background-color: #e71623;
        color: #fff;
      }
    }
    .titleH5 {
      padding: 0px 1.875rem;
      text-align: left;
      font-size: 0.1771rem;
      font-family: Microsoft YaHei;
      font-weight: 700;
      line-height: 0.3542rem;
      color: #444444;
      letter-spacing: 0.0052rem;
      opacity: 1;
      transition: 0.3s;
    }
    .titleH5_info {
      text-align: left;
      padding: 0px 1.875rem;
      font-size: 0.1042rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 0.2083rem;
      color: #999999;
      letter-spacing: 0.0052rem;
      opacity: 1;
    }
  }
  .case_box {
    width: 100%;
    height: 100%;
    .title_box {
      margin-top: 0.6208rem;
      color: #000;
    }
    .case_tab_box {
      display: flex;
      justify-content: space-between;
      margin: 0rem 1.7396rem;
      .case_tab_li {
        position: relative;
        width: 0.7083rem;
        height: 0.2969rem;
        border: 0.0052rem solid #999999;
        opacity: 1;
        border-radius: 0px;
        line-height: 0.2969rem;
        text-align: center;
        font-size: 0.0833rem;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: #444444;
        transition: 0.3s;
        z-index: 0;
        cursor: pointer;
        .case_tab_li_hover {
          position: absolute;
          width: 100%;
          height: 100%;
          opacity: 0;
          background: linear-gradient(270deg, #e71623 0%, #f5c071 100%);
          z-index: -1;
          transition: 0.3s;
        }
      }
      .case_tab_li:hover {
        color: #fff;
        .case_tab_li_hover {
          opacity: 1;
        }
      }
    }
    .case_swiper_box {
      position: relative;
      height: 2.6042rem;
      margin: 0.184rem 1.224rem;
      .left_prev {
        position: absolute;
        left: -0.6563rem;
        top: 50%;
        transform: translateY(-50%);
        width: 0.4271rem;
        height: 0.4271rem;
        background-color: #00000020;
        border-radius: 50%;
        transition: 0.3s;
        cursor: pointer;
        background-position: 43% center;
        background-image: url("../../static/images/icon/left_prev.png");
        background-repeat: no-repeat;
        background-size: 0.1042rem 0.1875rem;
      }
      .left_prev:hover {
        background-color: #00000080;
      }
      .left_next {
        position: absolute;
        right: -0.6563rem;
        top: 50%;
        transform: translateY(-50%);
        width: 0.4271rem;
        height: 0.4271rem;
        background-color: #00000020;
        border-radius: 50%;
        transition: 0.3s;
        cursor: pointer;
        background-position: 57% center;
        background-image: url("../../static/images/icon/left_next.png");
        background-repeat: no-repeat;
        background-size: 0.1042rem 0.1875rem;
      }
      .left_next:hover {
        background-color: #00000080;
      }
      .case_box_new {
        width: 2.3438rem;
        height: 2.3958rem;
        background-color: pink;
        box-shadow: 0 0 0.0521rem 0px #00000050;
      }
      .case_swiper_li {
        position: relative;
        width: 2.3438rem;
        height: 2.3958rem;
        margin: 0 auto;
        box-shadow: 0 0 0.0521rem 0px #00000050;
        .img_box {
          width: 100%;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
          }
        }

        .case_swiper_cover {
          position: absolute;
          top: 0px;
          left: 0px;
          width: 100%;
          height: 100%;
          background-color: #000000;
          opacity: 0;
          cursor: pointer;
          transition: 0.3s;
        }
        .case_swiper_cover:hover {
          background-color: #00000050;
          opacity: 1;
        }
      }
      .case_swiper_title {
        font-size: 0.125rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #000000;
        margin-top: 0.0521rem;
        opacity: 1;
      }
    }
    .more {
      position: relative;
      width: 0.9792rem;
      height: 0.2813rem;
      border: 0.0104rem solid #999999;
      opacity: 1;
      border-radius: 0.0208rem;
      margin: 0 auto;
      font-size: 0.1042rem;
      line-height: 0.2813rem;
      text-align: center;
      font-family: MicrosoftYaHei;
      color: #444444;
      opacity: 1;
      transition: 0.3s;
      cursor: pointer;
      .outline {
        position: absolute;
        top: -0.5rem;
        left: 0rem;
        width: 0.9792rem;
        height: 0.2813rem;
        border: 0.0104rem solid #999999;
        opacity: 0;
        transition: 0.3s;
        border-radius: 0.0208rem;
        pointer-events: none;
      }
    }
    .more:hover {
      color: #ff6100;
      .outline {
        position: absolute;
        top: -0.0104rem;
        left: -0.0104rem;
        width: 0.9742rem;
        height: 0.2713rem;
        border: 0.0154rem solid #ff6100;
        opacity: 1;
        border-radius: 0.0208rem;
      }
    }
  }

  .information_box {
    .title_box {
      margin-top: 0.6208rem;
      color: #000;
    }
    .classification_box {
      display: flex;
      justify-content: center;
      /* margin: 0rem 1.7396rem; */
      margin: 0 1.875rem;
      margin-top: 0.0821rem;
      text-align: center;
      .classification_btn {
        position: relative;
        display: inline-block;
        width: 0.9115rem;
        height: 0.2604rem;
        line-height: 0.2604rem;
        border: 0.0052rem solid #999999;
        opacity: 1;
        border-radius: 0px;
        margin: 0rem 0.1521rem;
        font-size: 0.1042rem;
        font-family: MicrosoftYaHei;
        color: #666666;
        opacity: 1;
        cursor: pointer;
        transition: 0.3s;
        .selectBackground {
          position: absolute;
          width: 101%;
          height: 101%;
          top: 0px;
          left: 0px;
          background: linear-gradient(270deg, #e71623 0%, #f5c071 100%);
          z-index: -1;
          opacity: 0;
          transition: 0.3s;
        }
      }
      .classification_btn:hover {
        color: #ffffff;
        border: 0.0052rem solid #ffffff00;
        font-weight: 700;
        .selectBackground {
          opacity: 1 !important;
        }
      }
      .selectclassification {
        color: #ffffff;
        border: 0.0052rem solid #ffffff00;
        font-weight: 700;
      }
    }
    .information_list_box {
      display: flex;
      margin: 0 1.875rem;
      margin-top: 0.1542rem;
      margin-bottom: 0.1592rem;
      .left_box {
        width: 3.9229rem;
        height: 2.5083rem;
        background: #a1a1a1;
        opacity: 1;
        border-radius: 0px;
        margin-right: 0.1979rem;
        position: relative;
        cursor: pointer;
        .img_box {
          width: 100%;
          height: 100%;
          background-color: skyblue;
          image {
            width: 100%;
            height: 100%;
          }
        }
        .bottom_box {
          position: absolute;
          bottom: 0rem;
          left: 0rem;
          height: 0.276rem;
          background: #00000070;
          width: 3.9229rem;
          line-height: 0.276rem;
          font-size: 0.1458rem;
          color: #fff;
        }
      }
      .time_box {
        position: absolute;
        top: 0rem;
        left: 0rem;
        width: 0.5rem;
        height: 0.4375rem;
        background-color: #ff6100;
        text-align: center;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        letter-spacing: 0.0104rem;
        opacity: 1;
        p {
          font-size: 0.0908rem;
          margin-top: 0.0521rem;
        }
        span {
          font-size: 0.1708rem;
          margin-top: 0.0521rem;
        }
      }
      .right_box {
        flex: 1;
        .time_box {
          width: 0.45rem;
          height: 0.3875rem;
          p {
            font-size: 0.0808rem;
            margin-top: 0.0521rem;
          }
          span {
            font-size: 0.1508rem;
            margin-top: 0.0521rem;
          }
        }
        .right_list_box {
          position: relative;
          height: 1.1571rem;
          width: 100%;
          background-color: pink;
          cursor: pointer;
          .bottom_box {
            position: absolute;
            bottom: 0rem;
            left: 0rem;
            height: 0.236rem;
            background: #00000070;
            width: 100%;
            line-height: 0.236rem;
            font-size: 0.1058rem;
            color: #fff;
          }
        }
      }
    }
    .more {
      position: relative;
      width: 0.9792rem;
      height: 0.2813rem;
      border: 0.0104rem solid #999999;
      opacity: 1;
      border-radius: 0.0208rem;
      margin: 0 auto;
      font-size: 0.1042rem;
      line-height: 0.2813rem;
      text-align: center;
      font-family: MicrosoftYaHei;
      color: #444444;
      opacity: 1;
      transition: 0.3s;
      cursor: pointer;
      .outline {
        position: absolute;
        top: -0.5rem;
        left: 0rem;
        width: 0.9792rem;
        height: 0.2813rem;
        border: 0.0104rem solid #999999;
        opacity: 0;
        transition: 0.3s;
        border-radius: 0.0208rem;
        pointer-events: none;
      }
    }
    .more:hover {
      color: #ff6100;
      .outline {
        position: absolute;
        top: -0.0104rem;
        left: -0.0104rem;
        width: 0.9742rem;
        height: 0.2713rem;
        border: 0.0154rem solid #ff6100;
        opacity: 1;
        border-radius: 0.0208rem;
      }
    }
  }
  .partner_box {
    margin: 0 1.875rem;
    .title_box {
      margin-top: 0.4908rem;
      color: #000;
    }
    .partner_ul_box {
      margin-top: 0.063rem;
      display: flex;
      justify-content: space-between;
      .width220 {
        width: 1.2458rem !important;
        transition: 0.3s;
        .img_box {
          width: 1.1458rem !important;
          height: 0.3208rem !important;
          margin: 0 auto;
          transition: 0.3s;
        }
      }
      .width220:hover {
        .img_box {
          width: 1.2458rem !important;
          height: 0.3708rem !important;
        }
      }
      .partner_li {
        width: 0.5208rem;
        cursor: pointer;
        position: relative;
        .img_box {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 0.4208rem;
          height: 0.4208rem;
          margin: 0 auto;
          transition: 0.3s;
        }
        p {
          font-size: 0.0842rem;
          font-family: MicrosoftYaHei;
          line-height: 0.1563rem;
          color: #000000;
          opacity: 1;
          padding-top: 0.6304rem;
          transition: 0.3s;
        }
      }
      .partner_li:hover {
        .img_box {
          width: 0.5008rem;
          height: 0.5008rem;
          box-shadow: 0 0 0.0921rem 0px #00000050;
        }
        p {
          font-size: 0.0942rem;
        }
      }
    }
    .contact_box {
      position: relative;
      text-align: center;
      font-size: 0.125rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 0.2708rem;
      color: #000000;
      letter-spacing: 0.0104rem;
      opacity: 1;
    }
    .contact_box::after {
      content: "";
      position: absolute;
      top: 70%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #ff610060;
      width: 0.5938rem;
      height: 0.0625rem;
      border-radius: 0.0313rem;
    }
    .contact_box::before {
      content: "contact us";
      position: absolute;
      top: 105%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 0.0729rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #f29912;
      letter-spacing: 0.0052rem;
      opacity: 1;
    }
    .existing_box {
      text-align: center;
      font-size: 0.1146rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 0.1rem;
      color: #2f2f2f;
      letter-spacing: 0.0104rem;
      opacity: 1;
      margin-bottom: 0.1042rem;
      span {
        color: #e71623;
        font-size: 0.1979rem;
      }
    }
    .form_box {
      text-align: left;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 0.1363rem;
      .input_box {
        width: 20%;
        height: 0.2044rem;
        background: #ecf3fc;
        border: 0.0052rem solid rgba(165, 163, 163, 0.4);
        font-size: 0.0938rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 0.2044rem;
        color: #959595;
        opacity: 1;
        padding: 0 0.0542rem;
        input {
          height: 0.1644rem;
          border: none;
          background-color: #ecf3fc;
          width: 58%;
          display: inline-block;
          outline: none;
        }
      }
    }
    .appointment {
      width: 2.6979rem;
      height: 0.3094rem;
      background: #ff6100;
      border: 0.0052rem solid rgba(165, 163, 163, 0.49019607843137253);
      opacity: 1;
      border-radius: 0.1823rem;
      margin: 0.0542rem auto;
      line-height: 0.3094rem;
      font-size: 0.1458rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      letter-spacing: 0.026rem;
      opacity: 1;
      cursor: pointer;
      transition: 0.3s;
      user-select: none;
    }
    .appointment:hover {
      background: #ff8e48;
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
}
</style>